import React from 'react';
import ServiceAreaMap from './ServiceAreaMap';
const CallToActionSection = () => {
  // Service areas with coordinates for Southwest Florida
  const serviceAreas = [{
    name: 'Naples',
    lat: 26.142,
    lng: -81.7948
  }, {
    name: 'Fort Myers',
    lat: 26.6406,
    lng: -81.8723
  }, {
    name: 'Cape Coral',
    lat: 26.5629,
    lng: -81.9495
  }, {
    name: 'Bonita Springs',
    lat: 26.3398,
    lng: -81.7787
  }, {
    name: 'Estero',
    lat: 26.4381,
    lng: -81.8067
  }, {
    name: 'Marco Island',
    lat: 25.9424,
    lng: -81.7077
  }, {
    name: 'Sanibel',
    lat: 26.4489,
    lng: -82.0221
  }, {
    name: 'Captiva',
    lat: 26.5221,
    lng: -82.1909
  }];
  return <section className="py-16 md:py-24 bg-gray-900 text-white" data-id="element-50">
      <div className="container mx-auto px-4" data-id="element-51">
        <div className="flex flex-col md:flex-row items-center justify-between" data-id="element-52">
          <div className="w-full md:w-2/3 mb-10 md:mb-0" data-id="element-53">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-54">
              Ready to Upgrade Your Technology Experience?
            </h2>
            <p className="text-xl text-gray-300 mb-8" data-id="element-55">
              Schedule your free consultation today and discover how our
              solutions can transform your home or business.
            </p>
            <div className="flex flex-wrap gap-4" data-id="element-56">
              <a href="tel:2392038333" className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-lg transition-colors duration-300 inline-flex items-center" data-id="element-57">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-58">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" data-id="element-59" />
                </svg>
                Call (239) 203-8333
              </a>
              <a href="#contact-form" className="bg-white hover:bg-gray-100 text-blue-600 font-bold py-3 px-8 rounded-lg transition-colors duration-300 inline-flex items-center" data-id="element-60">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-61">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" data-id="element-62" />
                </svg>
                Request a Quote
              </a>
            </div>
          </div>
          <div className="w-full md:w-1/3 bg-gradient-to-br from-blue-600 to-blue-800 rounded-xl p-8 shadow-xl" data-id="element-63">
            <h3 className="text-2xl font-bold mb-4" data-id="element-64">Service Areas</h3>
            <p className="mb-4" data-id="element-65">Proudly serving all of Southwest Florida:</p>
            {/* Interactive Service Area Map */}
            <div className="w-full h-48 rounded-lg mb-4 overflow-hidden" data-id="element-66">
              <ServiceAreaMap serviceAreas={serviceAreas} data-id="element-67" />
            </div>
            <div className="grid grid-cols-2 gap-2" data-id="element-68">
              {serviceAreas.map((city, idx) => <div key={idx} className="flex items-center" data-id="element-69">
                  <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20" data-id="element-70">
                    <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" data-id="element-71" />
                  </svg>
                  <span data-id="element-72">{city.name}</span>
                </div>)}
            </div>
            <div className="mt-8 pt-6 border-t border-blue-500" data-id="element-73">
              <p className="text-sm text-blue-200" data-id="element-74">
                Same-day service available for urgent needs in most areas. Call
                for details and availability.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default CallToActionSection;